import { db } from '@util/firebase';
import {
  collection,
  CollectionReference,
  getDocs,
  limit,
  where,
  orderBy,
  query
} from 'firebase/firestore';
import { ConditionDocument } from '@util/types/firestore/conditions';

export const colRef = collection(
  db, 'conditions'
) as CollectionReference<ConditionDocument>;

export async function getConditionByName(name: string | null) {
  if (!name) return null;

  const docRef = query(
    colRef,
    where("name", "==", name),
    limit(1)
  );
  const querySnapshot = await getDocs(docRef);
  if (querySnapshot.empty) {
    return null;
  }
  const data = querySnapshot.docs[0]?.data();
  return data ?? null;
}

export async function getConditions() {
  try {
    const q = query(
      colRef,
      orderBy("order", "asc")
    );

    const snapshot = await getDocs(q);
    return snapshot.docs.map((doc) => ({
      ...(doc.data() as ConditionDocument),
      id: doc.id,
    }));
  } catch (error) {
    console.error("Error fetching conditions:", error);
    return [];
  }
}
